// extracted by mini-css-extract-plugin
module.exports = {"pipelineDetailsRow":"review_pipelineDetailsRow__2q-Ih","rowSubTitle":"review_rowSubTitle__2E6qL","rowValues":"review_rowValues__3Elm5","actionBtns":"review_actionBtns__1FvOH"};